// InputComponent.jsx
import React from "react";
import UploadBestandInput from "../ImageUpload/UploadBestandInput";

const ReInputAttachtments = ({
  link,
  userdetails,
  formData,
  type,
  id,
  name,
  label,
  value,
  placeholder,
  setLoading,
  onChange,
  disabled = false,
  required = false,
}) => {
  const commonInputProps = {
    id,
    name,
    onChange,
    value,
    placeholder,
    className:
      "block w-full rounded-lg border border-wa-border bg-wa-panel2 px-4 py-3 text-sm text-wa-text shadow-sm placeholder:text-wa-muted focus:border-wa-accent/50 focus:outline-none focus:ring-2 focus:ring-wa-accent/20 sm:text-sm sm:leading-6",
  };

  let inputElement = null;

  switch (type) {
    case "text":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="text"
          {...commonInputProps}
        />
      );
      break;
    case "email":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="email"
          {...commonInputProps}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea disabled={disabled} rows={5} {...commonInputProps} />
      );
      break;
    case "checkbox":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="checkbox"
          {...commonInputProps}
        />
      );
      break;
    case "radio":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="radio"
          {...commonInputProps}
        />
      );
      break;
    case "date":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="date"
          {...commonInputProps}
        />
      );
      break;
    case "datetime":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="datetime"
          {...commonInputProps}
        />
      );
      break;
    default:
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="text"
          {...commonInputProps}
        />
      );
  }

  return (
    <div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <label
          htmlFor={id}
          className="block py-2 text-sm font-medium leading-6 text-wa-text"
        >
          {label}
        </label>
        {formData.id && (
          <UploadBestandInput
            linkbackend={link}
            userdetails={userdetails}
            formData={formData}
            setLoading={setLoading}
          />
        )}
      </div>
      <div className="mt-2">{inputElement}</div>
    </div>
  );
};

export default ReInputAttachtments;
